// extracted by mini-css-extract-plugin
export default {"rating":"NL-z","numberOfStars":"OL-z","count":"PL-z","barGraphSpacing":"QL-z","barGraph":"RL-z"};